import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-mt-none" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " 本規約に同意した上で当団体が提供する製品をご利用ください。 ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " また、本サイトで配布される配布物はMojang ABまたはMinecraftが作成または承認したものではなく、非商業目的物に該当するものです。 ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "第１条（定義）", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " 本規約上で使用する用語の定義は、次に掲げるとおりとします。 ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "第２条（本規約への同意）", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "第３条（規約の変更）", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("li", null, "当団体は、利用者の承諾を得ることなく、いつでも、本規約の内容を改定することができるものとし、利用者はこれを異議なく承諾するものとします。", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", null, "当団体は、本規約を改定するときは、その内容について本サイトを通じて利用者に通知します。", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("li", null, "前本規約の改定の効力は、当団体が前項により通知を行った時点から生じるものとします。", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("li", null, "利用者からのアクセスが逼迫するなど、システムの容量を超える利用がなされた場合", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", null, "第６条（費用負担）", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h2", null, "第７条（禁止行為）", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("li", null, "当団体または第三者の知的財産権を侵害する行為", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("li", null, "当団体または第三者の名誉・信用を毀損または不当に差別もしくは誹謗中傷する行為", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("li", null, "当団体または第三者の財産を侵害する行為、または侵害する恐れのある行為", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("li", null, "当団体または第三者に経済的損害を与える行為", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("li", null, "当団体または第三者に対する脅迫的な行為", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("li", null, "配布物に対して編集・加工等を行い、第三者に配布する行為", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("li", null, "コンピューターウィルス、有害なプログラムを仕様またはそれを誘発する行為", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("li", null, "当サイトのサーバーやシステム、セキュリティへの攻撃", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("li", null, "当団体提供のインターフェース以外の方法で当団体サービスにアクセスを試みる行為", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("li", null, "上記の他、当団体が不適切と判断する行為", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h2", null, "第８条（規約違反行為に対する措置）", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, "当団体は利用者が本規約及び各種規約等の何らの条項に違反した場合、当団体は平均的な損害の額に基づいた違約金の請求、合理的な弁護士費用も含む損害賠償請求等の措置を取ることができます。"),
  /*#__PURE__*/_createElementVNode("li", null, "利用者の規約違反行為に関連し、これに生起する第三者との間の法的請求や責任について、当団体は一切責任を負わず、利用規約等に違反した利用者は、自己の責任においてこれを処理し、当団体に一切の迷惑や損害を与えないことを保証します。"),
  /*#__PURE__*/_createElementVNode("li", null, "前項の法的請求が当団体に対して行われ、当団体が何らの損害を被った場合、利用者は、合理的な弁護士費用も含め、当団体が要した費用一切につき、これを補償します。"),
  /*#__PURE__*/_createElementVNode("li", null, "本コンテンツ又はその使用用途等について利用規約等違反の報告が当団体にあった場合、当団体は、当該違反の是正について合理的な範囲での最善の措置を講ずるよう努め、当団体の裁量で当団体が行う対応を決定することができます。")
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h2", null, "第９条（免責）", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("li", null, "当団体は、利用者その他の第三者に発生した機会逸失、業務の中断その他いかなる損害（間接損害や逸失利益を含みます）に対して、当団体が係る損害の可能性を事前に通知されていたとしても、一切の責任を負いません。", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("li", null, "第１項乃至前項の規定は、当団体に故意または重過失が存する場合又は契約書が消費者契約法上の消費者に該当する場合には適用しません。", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("li", null, "前項が適用される場合であっても、当団体は、過失（重過失を除きます。）による行為によって利用者に生じた損害のうち、特別な事情から生じた損害については、一切賠償する責任を負わないものとします。", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("li", null, "利用者と他の利用者との間の紛争及びトラブルについて、当団体は一切責任を負わないものとします。利用者と他の利用者でトラブルになった場合でも、両者同士の責任で解決するものとし、当団体には一切の請求をしないものとします。", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("li", null, "利用者の行為により、第三者から当団体が損害賠償等の請求をされた場合には、利用者の費用（弁護士費用）と責任で、これを解決するものとします。当団体が、当該第三者に対して、損害賠償金を支払った場合には、利用者は、当団体に対して当該損害賠償金を含む一切の費用（弁護士費用及び逸失利益を含む）を支払うものとします。", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h2", null, "第１０条（権利譲渡の禁止）", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("li", null, "利用者は、予め当団体の書面による承諾がない限り、本規約上の地位および本規約に基づく権利または義務の全部または一部を第三者に譲渡してはならないものとします。", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("h2", null, "第１１条（分離可能性）", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", null, " 本規約のいずれかの条項又はその一部が、消費者契約法その他の法令等により無効又は執行不能と判断された場合であっても、本規約の残りの規定及び一部が無効又は執行不能と判断された規定の残りの部分は、継続して完全に効力を有するものとします。 ", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h2", null, "第１２条（当団体への連絡方法）", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h2", null, "第１３条（準拠法、管轄裁判所）", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, "本規約の有効性，解釈及び履行については，日本法に準拠し，日本法に従って解釈されるものとします。"),
  /*#__PURE__*/_createElementVNode("li", null, "本規約に関して当団体と利用者等との間での論議・訴訟その他一切の紛争については、訴額に応じて、東京簡易裁判所又は東京地方裁判所を第一審の専属的合意管轄裁判所とします｡")
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h3", { class: "q-mb-none" }, "２０２３年５月１５日 施行", -1)

import IndentLine from '@/components/Works/IndentLine.vue';

interface Prop {
  productName?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TermsOfUse',
  props: {
    productName: null
  },
  setup(__props: any) {

const prop = __props as {
  productName?: string
};



const product = prop.productName ?? '配布物'
const generalProduct = prop.productName ? '本サービス' : '配布物'

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(product)) + "利用規約", 1),
    _createElementVNode("p", null, " この規約（以下「本規約」）は、お客様が、斜向（以下「当団体」）が提供する" + _toDisplayString(_unref(product)) + "（以下「" + _toDisplayString(_unref(generalProduct)) + "」）をご利用頂く際の取扱いにつき定めるものです。 ", 1),
    _hoisted_2,
    _createElementVNode("p", null, [
      _createTextVNode(" なお、"),
      _createVNode(_component_router_link, { to: "broadcast" }, {
        default: _withCtx(() => [
          _createTextVNode("投稿規約")
        ]),
        _: 1
      }),
      _createTextVNode("は、本規約と一体となって" + _toDisplayString(_unref(generalProduct)) + "の利用に適用されるものとします。 ", 1)
    ]),
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _createElementVNode("ol", null, [
      _createElementVNode("li", null, [
        _createVNode(IndentLine, {
          title: "本サイト",
          comment: `${_unref(generalProduct)}のコンテンツが掲載されたウェブサイト`
        }, null, 8, ["comment"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(IndentLine, {
          title: "本コンテンツ",
          comment: `${_unref(generalProduct)}上で提供される文字、音、静止画、動画、ソフトウェアプログラム、コード等の総称（投稿情報を含む）`
        }, null, 8, ["comment"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(IndentLine, {
          title: "利用者",
          comment: `${_unref(generalProduct)}を利用する全ての方`
        }, null, 8, ["comment"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(IndentLine, {
          title: "個人情報",
          comment: "住所、氏名、職業、電話番号等個人を特定することのできる情報の総称"
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(IndentLine, {
          title: "知的財産",
          comment: "発明、考案、植物の新品種、意匠、著作物その他の人間の創造的活動により生み出されるもの（発見または解明がされた自然の法則または現象であって、産業上の利用可能性があるものを含む）、商標、商号その他事業活動に用いられる商品または役務を表示するもの及び営業秘密その他の事業活動に有用な技術上または営業上の情報"
        })
      ])
    ]),
    _hoisted_6,
    _createElementVNode("ol", null, [
      _createElementVNode("li", null, "利用者は、本利用規約に同意頂いた上で、" + _toDisplayString(_unref(generalProduct)) + "を利用できるものとします。", 1),
      _createElementVNode("li", null, "利用者が、" + _toDisplayString(_unref(generalProduct)) + "をデスクトップPCその他の情報端末にダウンロードする際に、本規約への同意手続を行った時点で、利用者と当団体との間で、本規約の諸規定に従った利用契約が成立するものとします。", 1),
      _createElementVNode("li", null, "利用者が未成年者である場合には、親権者その他の法定代理人の同意を得たうえで、" + _toDisplayString(_unref(generalProduct)) + "をご利用ください。", 1),
      _createElementVNode("li", null, "未成年者の利用者が、法定代理人の同意がないにもかかわらず同意があると偽りまたは年齢について成年と偽って" + _toDisplayString(_unref(generalProduct)) + "を利用した場合、その他行為能力者であることを信じさせるために詐術を用いた場合、" + _toDisplayString(_unref(generalProduct)) + "に関する一切の法律行為を取り消すことは出来ません。", 1),
      _createElementVNode("li", null, "本規約の同意時に未成年であった利用者が成年に達した後に" + _toDisplayString(_unref(generalProduct)) + "を利用した場合、当該利用者は" + _toDisplayString(_unref(generalProduct)) + "に関する一切の法律行為を追認したものとみなされます。", 1)
    ]),
    _hoisted_7,
    _createElementVNode("ol", null, [
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _createElementVNode("li", null, "利用者は、本規約変更後、" + _toDisplayString(_unref(generalProduct)) + "を利用した時点で、変更後の本規約に異議なく同意したものとみなされます。", 1)
    ]),
    _createElementVNode("h2", null, "第４条（" + _toDisplayString(_unref(generalProduct)) + "の一時中断、停止）", 1),
    _createElementVNode("p", null, " 当団体は以下に該当する場合、利用者への事前の告知なしで、" + _toDisplayString(_unref(generalProduct)) + "の一部または全部を一時停止または中止することができるものとします。 ", 1),
    _createElementVNode("ol", null, [
      _createElementVNode("li", null, _toDisplayString(_unref(generalProduct)) + "の保守点検、更新を定期的または緊急に行う場合", 1),
      _hoisted_11,
      _createElementVNode("li", null, "火災、停電、天災などの不可抗力により、" + _toDisplayString(_unref(generalProduct)) + "の提供が困難な場合", 1),
      _createElementVNode("li", null, "運用上または技術上の理由により、当団体が" + _toDisplayString(_unref(generalProduct)) + "の一時停止または中止が必要であると判断した場合", 1),
      _createElementVNode("li", null, "その他、不測の事態により当団体が" + _toDisplayString(_unref(generalProduct)) + "の提供が困難と判断した場合", 1)
    ]),
    _createElementVNode("h2", null, "第５条（" + _toDisplayString(_unref(generalProduct)) + "の変更と終了）", 1),
    _createElementVNode("ol", null, [
      _createElementVNode("li", null, "当団体は、利用者に事前に告知することなく、当団体の判断により" + _toDisplayString(_unref(generalProduct)) + "内容の一部または全部を変更できるものとします。", 1),
      _createElementVNode("li", null, "当団体は、利用者に事前に告知することなく当団体の判断により" + _toDisplayString(_unref(generalProduct)) + "内容の一部または全部を終了できるものとします。", 1),
      _createElementVNode("li", null, "当団体は、" + _toDisplayString(_unref(generalProduct)) + "内容の変更による利用者及び第三者の不利益に対し一切の責任を負わないものとします。", 1)
    ]),
    _hoisted_12,
    _createElementVNode("p", null, _toDisplayString(_unref(generalProduct)) + "を利用するにあたり必要となる端末機器、通信機器、通信手段及び電力等は、利用者の費用と責任で用意するものとします。 ", 1),
    _hoisted_13,
    _createElementVNode("p", null, _toDisplayString(_unref(generalProduct)) + "の利用に際し、当団体は、利用者に対し、次に掲げる行為を禁止します。 ", 1),
    _createElementVNode("ol", null, [
      _hoisted_14,
      _hoisted_15,
      _hoisted_16,
      _hoisted_17,
      _hoisted_18,
      _hoisted_19,
      _hoisted_20,
      _createElementVNode("li", null, _toDisplayString(_unref(generalProduct)) + "用インフラ設備に対して過度な負担となるストレスをかける行為", 1),
      _hoisted_21,
      _hoisted_22,
      _hoisted_23
    ]),
    _hoisted_24,
    _hoisted_25,
    _hoisted_26,
    _createElementVNode("ol", null, [
      _createElementVNode("li", null, "当団体は、" + _toDisplayString(_unref(generalProduct)) + "の内容変更、中断、終了によって生じたいかなる損害についても、一切責任を負いません。", 1),
      _createElementVNode("li", null, "当団体は、利用者の" + _toDisplayString(_unref(generalProduct)) + "の利用環境について一切関与せず、また一切の責任を負いません。", 1),
      _createElementVNode("li", null, "当団体は、" + _toDisplayString(_unref(generalProduct)) + "が利用者の特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、利用者による" + _toDisplayString(_unref(generalProduct)) + "の利用が利用者に適用のある法令または業界団体の内部規則等に適合すること、および不具合が生じないことについて、何ら保証するものではありません。", 1),
      _createElementVNode("li", null, "当団体は、" + _toDisplayString(_unref(generalProduct)) + "が全ての情報端末に対応していることを保証するものではなく、" + _toDisplayString(_unref(generalProduct)) + "の利用に供する情報端末のＯＳのバージョンアップ等に伴い、" + _toDisplayString(_unref(generalProduct)) + "の動作に不具合が生じる可能性があることにつき、利用者はあらかじめ了承するものとします。当団体は、かかる不具合が生じた場合に当団体が行うプログラムの修正等により、当該不具合が解消されることを保証するものではありません。", 1),
      _createElementVNode("li", null, "利用者は、GitHub, Google Drive等のサービスストアの利用規約および運用方針の変更等に伴い、" + _toDisplayString(_unref(generalProduct)) + "の一部又は全部の利用が制限される可能性があることをあらかじめ了承するものとします。", 1),
      _createElementVNode("li", null, "当団体は、" + _toDisplayString(_unref(generalProduct)) + "を利用したことにより直接的または間接的に利用者に発生した損害について、一切賠償責任を負いません。", 1),
      _hoisted_27,
      _hoisted_28,
      _hoisted_29,
      _createElementVNode("li", null, _toDisplayString(_unref(generalProduct)) + "の利用に関し当団体が損害賠償責任を負う場合、当該損害が発生した月に利用者から受領した利用額を限度として賠償責任を負うものとします。", 1),
      _hoisted_30,
      _createElementVNode("li", null, "利用者は、" + _toDisplayString(_unref(generalProduct)) + "の利用に関連し、他の利用者に損害を与えた場合または第三者との間に紛争を生じた場合、自己の費用と責任において、かかる損害を賠償またはかかる紛争を解決するものとし、当団体には一切の迷惑や損害を与えないものとします。", 1),
      _hoisted_31,
      _createElementVNode("li", null, "利用者が" + _toDisplayString(_unref(generalProduct)) + "の利用に関連して当団体に損害を与えた場合、利用者の費用と責任において当団体に対して損害を賠償（訴訟費用及び弁護士費用を含む）するものとします。", 1)
    ]),
    _hoisted_32,
    _createElementVNode("ol", null, [
      _hoisted_33,
      _createElementVNode("li", null, "当団体は、" + _toDisplayString(_unref(generalProduct)) + "の全部または一部を当団体の裁量により第三者に譲渡することができ、その場合、譲渡された権利の範囲内で利用者のアカウントを含む、" + _toDisplayString(_unref(generalProduct)) + "に係る利用者の一切の権利が譲渡先に移転するものとします。", 1)
    ]),
    _hoisted_34,
    _hoisted_35,
    _hoisted_36,
    _createElementVNode("p", null, [
      _createTextVNode(_toDisplayString(_unref(generalProduct)) + "に関する利用者の当団体へのご連絡・お問い合わせは、", 1),
      _createVNode(_component_router_link, { to: "/contact" }, {
        default: _withCtx(() => [
          _createTextVNode("当団体が本サイト上で指定する方法")
        ]),
        _: 1
      }),
      _createTextVNode("により行うものとします。 ")
    ]),
    _hoisted_37,
    _hoisted_38,
    _hoisted_39
  ], 64))
}
}

})